export const ArrowUpLeftSvg = ({
  fillColor = "none",
}: {
  fillColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill={fillColor}
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="icon icon-tabler icons-tabler-outline icon-tabler-arrow-up-left"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M7 7l10 10" />
    <path d="M16 7l-9 0l0 9" />
  </svg>
);
